import React, { useEffect, useState } from 'react';
import { IonIcon } from '@ionic/react';
import { cloudOfflineOutline, cloudOutline } from 'ionicons/icons';

interface OnlineIndicatorProps {
    className?: string;
    style?: React.CSSProperties;
}

const OnlineIndicator: React.FC<OnlineIndicatorProps> = ({ className = '', style = {} }) => { // Provide default empty object
    const [ isOnline, setIsOnline ] = useState<boolean>(navigator.onLine);

    useEffect(() => {
        const handleOnlineStatusChange = () => {
            setIsOnline(navigator.onLine);
        };

        window.addEventListener('online', handleOnlineStatusChange);
        window.addEventListener('offline', handleOnlineStatusChange);

        return () => {
            window.removeEventListener('online', handleOnlineStatusChange);
            window.removeEventListener('offline', handleOnlineStatusChange);
        };
    }, []);

    return (
      <IonIcon
        icon={isOnline ? cloudOutline : cloudOfflineOutline}
        color={isOnline ? "success" : "medium"}
        className={`online-status-icon ${className}`}
        style={{ 
          fontSize: '16px', 
          marginRight: '16px', 
          alignSelf: 'flex-end',
          marginBottom: '4px',
          ...style // Now style is properly defined
        }}
      />
    );
};

export default OnlineIndicator;